// Angular
import { RouterOutlet } from "@angular/router";
import { Component, inject } from "@angular/core";

// Services
import { LoaderService } from "#services/loader/loader.service";

// Components
import { LoaderComponent } from "#components/loader/loader.component";

@Component({
    selector: "app-template-guest",
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: "./template-guest.component.html",
    styleUrl: "./template-guest.component.scss",
})
export class TemplateGuestComponent {
    loaderService = inject(LoaderService);
}
